import { useQuery } from '@tanstack/react-query'
import { get } from '@/lib/api'
import { DecisionCount } from '../types/insights'

export function usePacketsByDecision(year?: string) {
  return useQuery({
    queryKey: ['insights', 'packets-by-decision', year],
    queryFn: async () => {
      const params = year ? { year } : undefined
      const response = await get<{ data: DecisionCount[] }>('/insights/packets-by-decision', params)
      return response.data
    },
    staleTime: 1000 * 60 * 60, // 1 hour
    gcTime: 1000 * 60 * 60 * 2, // 2 hours
  })
} 